import { render, staticRenderFns } from "./RankingTab.vue?vue&type=template&id=a3f08b9c&scoped=true"
import script from "./RankingTab.vue?vue&type=script&lang=js"
export * from "./RankingTab.vue?vue&type=script&lang=js"
import style0 from "./RankingTab.vue?vue&type=style&index=0&id=a3f08b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f08b9c",
  null
  
)

export default component.exports